import React from "react";
import { Info } from "lucide-react";

/** Hover/focus info icon used on metric titles and table headers. */
export function MetricInfoTooltip({
    text,
    label = "More info"
}: {
    text: React.ReactNode;
    label?: string;
}) {
    return (
        <span className="group relative inline-flex">
            <Info
                aria-label={label}
                className="h-3.5 w-3.5 cursor-help text-gray-400 transition-colors group-hover:text-gray-600 group-focus-within:text-gray-600"
                tabIndex={0}
            />
            <span
                role="tooltip"
                className="pointer-events-none absolute left-0 top-full z-20 mt-2 w-64 whitespace-pre-line rounded-md bg-gray-900 px-3 py-2 text-xs leading-relaxed text-white opacity-0 shadow-md transition-opacity duration-150 group-hover:opacity-100 group-focus-within:opacity-100"
            >
                {text}
            </span>
        </span>
    );
}

/** Share of voice (competitors landscape chart). */
export const SHARE_OF_VOICE_TOOLTIP =
    "Shows how much of the AI conversation each brand owns versus you and your competitors. Shares always add up to 100%, so one brand rising can lower another even if its own mentions stay flat.\n\nFormula: Brand mentions ÷ Total mentions (you + competitors) × 100";

/** Competitor visibility trend chart. */
export const COMPETITOR_VISIBILITY_TREND_TOOLTIP =
    "Tracks how often each brand appears in AI answers over time for your tracked prompts.\n\nFormula: Answers mentioning the brand ÷ Total AI answers × 100";

/** Visibility column on the competitors table. */
export const COMPETITOR_VISIBILITY_TOOLTIP =
    "How often this brand shows up in AI answers for your tracked prompts.\n\nFormula: Answers mentioning the brand ÷ Total AI answers × 100";

/** Rank column on the competitors table. */
export const COMPETITOR_RANK_TOOLTIP =
    "Where the brand usually sits in the list of brands named in an answer. Lower is better — 1 means it was mentioned first.\n\nFormula: Average mention position across answers that include the brand";
